import React, { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../login/auth-guard/AuthContext";
import "./AdminLayout.scss";

interface AdminLayoutProps {
  children?: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    {
      id: "articles",
      label: "게시글 관리",
      icon: "📝",
      path: "/admin",
    },
    {
      id: "categories",
      label: "카테고리 관리",
      icon: "📁",
      path: "/admin/categories",
    },
    {
      id: "keywords",
      label: "키워드 관리",
      icon: "🏷️",
      path: "/admin/keywords",
    },
    {
      id: "products",
      label: "제품 관리",
      icon: "🛍️",
      path: "/admin/products",
    },
    {
      id: "authors",
      label: "작성자 관리",
      icon: "👤",
      path: "/admin/authors",
    },
  ];

  const isActivePath = (path: string) => {
    if (path === "/admin") {
      return (
        location.pathname === "/admin" ||
        location.pathname === "/admin/articles"
      );
    }
    return location.pathname.startsWith(path);
  };

  const handleLogout = () => {
    if (window.confirm("정말 로그아웃하시겠습니까?")) {
      logout();
    }
  };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? "open" : "closed"}`}>
        <div className="sidebar-header">
          <h2 className="sidebar-title">Admin Panel</h2>
          <button
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            {sidebarOpen ? "◀" : "▶"}
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul className="nav-list">
            {menuItems.map((item) => (
              <li key={item.id} className="nav-item">
                <button
                  className={`nav-link ${isActivePath(item.path) ? "active" : ""}`}
                  onClick={() => navigate(item.path)}
                >
                  <span className="nav-icon">{item.icon}</span>
                  {sidebarOpen && (
                    <span className="nav-label">{item.label}</span>
                  )}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </aside>

      {/* Main Content */}
      <div className="admin-main">
        {/* Header */}
        <header className="admin-header">
          <div className="header-left">
            <button
              className="mobile-menu-toggle"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              ☰
            </button>
            <h1 className="page-title">
              {menuItems.find((item) => isActivePath(item.path))?.label ||
                "Admin"}
            </h1>
          </div>

          <div className="header-right">
            <div className="user-info">
              <span className="user-name">{user?.username}</span>
              <button className="logout-btn" onClick={handleLogout}>
                로그아웃
              </button>
            </div>
          </div>
        </header>

        {/* Content Area */}
        <main className="admin-content">{children || <Outlet />}</main>
      </div>
    </div>
  );
};

export default AdminLayout;
